module.exports = __webpack_public_path__ + "static/puppy-in-hand-2-11f2853f491b9548165066e0b896b70d.jpg";